module.exports = __webpack_public_path__ + "media/images/products/at1/at1-1-1000x1000-4a9d1eef2cb334f35e9b0065bce3df50.png";